exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-toggle::after {\n\tdisplay:none;\n}\n.pro-img img {\n    width: 200px;\n    height: 200px;\n    display: block;\n    -o-object-fit: cover;\n       object-fit: cover;\n    border-radius: 100%;\n}\n.profile-img-bg {\n    margin-bottom: 20px;\n}\n.pro-img-btn .ui-button-text,\n.pro-img-btn .btn-danger {\n\tpadding: .5rem 1rem;\n    min-width: 120px;\n\tmargin-top: 6px;\n}\n.speaker-grp .pro-img-btn {\n    margin-top: 40px;\n}\n.speaker-checkbox {\n    margin-top: 15px;\n}\n.m-t-15 {\n\tmargin-top:15px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /workspace/backend-server/src/app/event/speaker-add/speaker-add.component.css
// module id = ../../../../../src/app/event/speaker-add/speaker-add.component.css
// module chunks = main